import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { EdpResponseBody } from "@edp-models/response.model";
import { ApiEsService } from "./api-es.service";
import { ServiceES, ServiceFactoryES } from "@edp-models/ES/es-service.model";
import { ApiService } from "@edp-services/api.service";


@Injectable({
    providedIn: "root",
})
export class ServiceESService {
    constructor(
        private apiService: ApiService
    ) {
    }
    public getGrouped(body: object, _fromCache: boolean = true): Observable<ServiceES[]> {
        return this.apiService.callServicePost(`supportMotives.getGrouped`, body).pipe(
            map((response: EdpResponseBody) => {
                return response.Result.Collection.map((service: any) => this.createService(service));
            })
        );
    }

    public createService(service: ServiceES): ServiceES {
        return ServiceFactoryES.create({
            acronym: service.acronym,
            description: service.description,
            name: service.name,
            id: service.id,
            childs: service.childs,
            isSelected: false,
            intervention: service.intervention,
            externalCategory: service.externalCategory,
            selfcare: service.selfcare,
            action: service.action,
            actionLink: service.actionLink,
            typeRoute: service.typeRoute,
            category: service.category,
            type: service.type,
            subtype: service.subtype
        } as ServiceES);
    }

}
